class BundleDetails extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    await this.fetchBundleDetails()
  }

  async fetchBundleDetails () {
    this.innerHTML = ''

    await window.BAO.sectionRenderer
      .fetchSingle('bundle-details', this.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const colours = newDOM.querySelector(
          '[data-bundle-details-el="colours"]',
        )
        const label = newDOM.querySelector('[data-bundle-details-el="label"]')

        if (colours || label) {
          this.setAttribute('aria-hidden', false)
        }

        if (colours) {
          this.innerHTML = colours.outerHTML
        }

        if (label) {
          this.innerHTML += label.outerHTML

          const card = this.closest('.prd-Card')
          const quickViewButton = card.querySelector(
            '.prd-Card_QuickViewButton',
          )

          if (quickViewButton) {
            quickViewButton.innerHTML = `
              ${window.theme.strings.preOrder}

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M13.125 7.969c-.239 2.887-2.676 5.156-5.625 5.156A5.625 5.625 0 0 1 1.875 7.5c0-2.949 2.269-5.387 5.156-5.625"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M7.5 4.219V7.5h3.281"/><path fill="currentColor" d="M9.375 2.813a.703.703 0 1 0 0-1.407.703.703 0 0 0 0 1.407ZM11.484 4.219a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM12.89 6.328a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406Z"/>
              </svg>
          `
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
}

if (!customElements.get('bundle-details')) {
  customElements.define('bundle-details', BundleDetails)
}
